'use client';

import SvgDelete from '@common/__generated__/icon/SvgDelete';
import { Button, Modal } from '@common/components';
import { SvgSuccess } from '@common/icon';

interface DonationReservationCompleteModalProps {
  opened: boolean;
  onClose?: () => void;
}

/**
 * * 기부 사전예약 임시 모달
 */
export const DonationReservationCompleteModal = ({
  opened,
  onClose,
}: DonationReservationCompleteModalProps) => {
  return (
    <Modal
      opened={opened}
      onClose={onClose}
      className="relative max-h-[90%] min-w-280 p-0 lg:max-h-[90%] lg:min-w-280 lg:p-0"
    >
      <div className="flex flex-col items-center gap-8 px-20 pb-24 pt-32">
        <SvgSuccess className="size-20 text-G-300" />

        <p className="font-700 text-Gray-900 typo-body2">기부 사전 예약 완료</p>
        <p className="font-400 text-Gray-700 typo-body3">
          기부 사전 예약이 완료되었습니다.
          <br />
          기부 오픈 시 발송되는
          <br />
          카카오 알림톡을 꼭 확인해주세요!
        </p>
      </div>
      <Button
        theme="sub-text"
        className="absolute right-22 top-18 size-fit p-0"
        onClick={onClose}
      >
        <SvgDelete className="size-24 text-Gray-900" />
      </Button>
    </Modal>
  );
};
